export default __webpack_public_path__ + "static/media/qpmp_ive4_211101.615dafba.jpg";